import React, { Fragment } from "react";

interface IProps {
    alertInfo: any;
}

const IDFCourtRecords = ({ alertInfo }: any) => {
    const courtRecordsAlertdetails = alertInfo && alertInfo.length > 0 && alertInfo[0].alertDetails && alertInfo[0].alertDetails.alertItemDetailsList;

    if (!courtRecordsAlertdetails) {
        return <Fragment></Fragment>;
    }

    return (
        <>
            {courtRecordsAlertdetails.map((alert: any, index: number) => {
                let keys = Object.keys(alert);

                return (
                    <>
                        {keys.length !== 0 && (
                            <div role="listitem" className="data-row" key={index}>
                                <div className="link-item">
                                    <button
                                        type="button"
                                        aria-expanded="false"
                                        className="link-button"
                                        id={`alert-${index}`}
                                        onClick={() => toggle(`alert-${index}-details`, `alert-${index}`)}
                                    >
                                        <span className="row link-item">
                                            <div role="row" className="data-row condensed row">
                                                <span className="link-title">
                                                    <span className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status" style={{ display: "none" }}>
                                                        Show
                                                    </span>
                                                </span>

                                                {
                                                    <Fragment>
                                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter btn-toggle-status">
                                                            <div className="data-label">Name</div>
                                                        </div>
                                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                            <div className="data-value" aria-labelledby={`alert-${index}-Name`}>{`${alert["Name"]}`}</div>
                                                        </div>
                                                    </Fragment>
                                                }
                                            </div>
                                        </span>
                                    </button>
                                    <div
                                        className="wallet-details"
                                        key={alert.alertId}
                                        id={`alert-${index}-details`}
                                        style={{ display: "none", backgroundColor: "#F2F2F2" }}
                                        aria-hidden="true"
                                    >
                                        <div role="grid" className="data-grid row-height-xs" aria-labelledby={"alert-" + index + "-title"}>
                                            {keys.map((key: any) => {
                                                return (
                                                    <div role="row" key={`${key}-${index}`} className="data-row condensed row">
                                                        {key !== "Name" && (
                                                            <>
                                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                                    <div className="data-label" id={`alert-${index}-${key}`}>
                                                                        {key}
                                                                    </div>
                                                                </div>
                                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                                    <div className="data-value" aria-labelledby={`alert-${index}-${key}`}>
                                                                        {alert[key]}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                );
            })}
        </>
    );
};

export default IDFCourtRecords;
